export const ERROR_500_MESSAGE = "Unknown error";
